import React from 'react';

import { UserDtoProfileEnum } from 'lib_api/lib/api/gen';

import './UserIcon.less';

interface UserIconProps {
  firstName: string;
  lastName: string;
  profile?: UserDtoProfileEnum;
}

export const UserIcon: React.FC<UserIconProps> = ({
  firstName,
  lastName,
  profile,
}: UserIconProps): React.ReactElement => {
  const className = profile ? `userIcon userIcon--${profile}` : 'userIcon';

  return (
    <div className={className}>
      <p>
        {firstName.substring(0, 1)}
        {lastName.substring(0, 1)}
      </p>
    </div>
  );
};
